import React from "react";
import "./DonationsButton.css";

function DonationsButton({ onClick, ariaLabel, title }) {
  return (
    <button
      className="donations-button"
      onClick={onClick}
      aria-label={ariaLabel}
      title={title}
    >
      <span className="bitcoin-logo">₿</span>
    </button>
  );
}

export default DonationsButton;

